<template>
  <b-modal v-model="modal" :title="title" size="xl" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading :active.sync="loading" color="#556ee6" loader="dots" :is-full-page="false"></loading>

    <form @submit.prevent="saveBlock" autocomplete="off">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Nome <span class="text-danger">*</span></label>
            <input type="text" class="form-control" v-model="block.name" :class="{ 'is-invalid': $v.block.name.$error }" placeholder="Ex: Voos Galo SP-Salvador">
            <div v-if="$v.block.name.$error" class="invalid-feedback">Nome é obrigatório.</div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Grupo</label>
            <select class="form-control" v-model="block.group_id">
              <option :value="null">Global (todos os grupos)</option>
              <option v-for="g in groups" :key="g.id" :value="g.id">{{ g.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label>Ativo</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" v-model="block.is_active" id="blockActive">
              <label class="form-check-label" for="blockActive">{{ block.is_active ? 'Sim' : 'Não' }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Descrição</label>
            <textarea class="form-control" v-model="block.description" rows="2" placeholder="Notas internas sobre esse bloqueio (opcional)"></textarea>
          </div>
        </div>
      </div>

      <hr>

      <!-- Voos de IDA -->
      <div class="row mb-2">
        <div class="col-sm-12 d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            <i class="mdi mdi-airplane-takeoff text-success mr-1"></i>
            Voos de IDA <small class="text-muted">({{ idaItems.length }})</small>
          </h5>
          <button type="button" class="btn btn-sm btn-outline-success" @click="addItem('IDA')">
            <i class="mdi mdi-plus"></i> Adicionar IDA
          </button>
        </div>
      </div>

      <div v-for="(item, idx) in idaItems" :key="'ida-' + idx" class="item-card">
        <div class="row">
          <div class="col-md-2">
            <label class="small">Companhia</label>
            <input type="text" class="form-control form-control-sm" v-model="item.airline" placeholder="Ex: LATAM">
          </div>
          <div class="col-md-2">
            <label class="small">Nº do voo</label>
            <input type="text" class="form-control form-control-sm" v-model="item.flight_number" placeholder="Ex: LA3701">
          </div>
          <div class="col-md-2">
            <label class="small">Origem</label>
            <input type="text" class="form-control form-control-sm" v-model="item.origin" placeholder="Ex: GRU">
          </div>
          <div class="col-md-2">
            <label class="small">Destino</label>
            <input type="text" class="form-control form-control-sm" v-model="item.destination" placeholder="Ex: SSA">
          </div>
          <div class="col-md-2">
            <label class="small">Localizador</label>
            <input type="text" class="form-control form-control-sm" v-model="item.locator" placeholder="PNR (opcional)">
          </div>
          <div class="col-md-2 d-flex align-items-end">
            <button type="button" class="btn btn-sm btn-outline-danger w-100 mb-1" @click="removeItem(item)">
              <i class="bx bx-trash"></i> Remover
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6">
            <label class="small">Embarque</label>
            <input type="datetime-local" class="form-control form-control-sm" v-model="item.boarding_date">
          </div>
          <div class="col-md-6">
            <label class="small">Desembarque</label>
            <input type="datetime-local" class="form-control form-control-sm" v-model="item.landing_date">
          </div>
        </div>
      </div>

      <hr>

      <!-- Voos de VOLTA -->
      <div class="row mb-2">
        <div class="col-sm-12 d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            <i class="mdi mdi-airplane-landing text-warning mr-1"></i>
            Voos de VOLTA <small class="text-muted">({{ voltaItems.length }})</small>
          </h5>
          <button type="button" class="btn btn-sm btn-outline-warning" @click="addItem('VOLTA')">
            <i class="mdi mdi-plus"></i> Adicionar VOLTA
          </button>
        </div>
      </div>

      <div v-for="(item, idx) in voltaItems" :key="'volta-' + idx" class="item-card">
        <div class="row">
          <div class="col-md-2">
            <label class="small">Companhia</label>
            <input type="text" class="form-control form-control-sm" v-model="item.airline" placeholder="Ex: LATAM">
          </div>
          <div class="col-md-2">
            <label class="small">Nº do voo</label>
            <input type="text" class="form-control form-control-sm" v-model="item.flight_number" placeholder="Ex: LA3702">
          </div>
          <div class="col-md-2">
            <label class="small">Origem</label>
            <input type="text" class="form-control form-control-sm" v-model="item.origin" placeholder="Ex: SSA">
          </div>
          <div class="col-md-2">
            <label class="small">Destino</label>
            <input type="text" class="form-control form-control-sm" v-model="item.destination" placeholder="Ex: GRU">
          </div>
          <div class="col-md-2">
            <label class="small">Localizador</label>
            <input type="text" class="form-control form-control-sm" v-model="item.locator" placeholder="PNR (opcional)">
          </div>
          <div class="col-md-2 d-flex align-items-end">
            <button type="button" class="btn btn-sm btn-outline-danger w-100 mb-1" @click="removeItem(item)">
              <i class="bx bx-trash"></i> Remover
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6">
            <label class="small">Embarque</label>
            <input type="datetime-local" class="form-control form-control-sm" v-model="item.boarding_date">
          </div>
          <div class="col-md-6">
            <label class="small">Desembarque</label>
            <input type="datetime-local" class="form-control form-control-sm" v-model="item.landing_date">
          </div>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close">Cancelar</b-button>
      <b-button variant="primary" @click="saveBlock" :disabled="saving">
        <i class="mdi mdi-content-save mr-1"></i>
        {{ saving ? 'Salvando...' : 'Salvar' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Loading from 'vue-loading-overlay'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import http from '@/http'

const emptyBlock = () => ({
  id: null,
  name: '',
  description: '',
  group_id: null,
  is_active: true,
  items: []
})

const emptyItem = (type) => ({
  id: null,
  type_flight: type,
  airline: '',
  origin: '',
  destination: '',
  flight_number: '',
  boarding_date: null,
  landing_date: null,
  locator: '',
  order: 0
})

export default {
  components: { Loading },
  props: {
    value: { type: Boolean, default: false }
  },
  data () {
    return {
      modal: this.value,
      title: 'Novo bloqueio',
      loading: false,
      saving: false,
      block: emptyBlock(),
      groups: []
    }
  },
  validations: {
    block: {
      name: { required }
    }
  },
  computed: {
    idaItems () {
      return this.block.items.filter(i => i.type_flight === 'IDA')
    },
    voltaItems () {
      return this.block.items.filter(i => i.type_flight === 'VOLTA')
    }
  },
  methods: {
    ...mapActions('flightBlocks', ['show', 'save', 'update']),
    async open (id = null) {
      this.$v.$reset()
      this.block = emptyBlock()
      this.modal = true
      this.loading = true
      await this.loadGroups()
      if (id) {
        this.title = 'Editar bloqueio'
        try {
          const res = await http.get(`/admin/flight-blocks/${id}`)
          const data = res.data.data
          this.block = {
            id: data.id,
            name: data.name,
            description: data.description || '',
            group_id: data.group_id,
            is_active: !!data.is_active,
            items: (data.items && data.items.data ? data.items.data : data.items || []).map(i => ({
              id: i.id,
              type_flight: i.type_flight,
              airline: i.airline || '',
              origin: i.origin || '',
              destination: i.destination || '',
              flight_number: i.flight_number || '',
              boarding_date: this.toDateTimeLocal(i.boarding_date),
              landing_date: this.toDateTimeLocal(i.landing_date),
              locator: i.locator || '',
              order: i.order || 0
            }))
          }
        } catch (err) {
          errorMessage('Erro ao carregar bloqueio.')
          this.close()
        }
      } else {
        this.title = 'Novo bloqueio'
      }
      this.loading = false
    },
    async loadGroups () {
      try {
        const res = await http.get('/admin/groups', { params: { limit: 500 } })
        this.groups = (res.data && res.data.data) ? res.data.data : []
      } catch (err) {
        this.groups = []
      }
    },
    addItem (type) {
      this.block.items.push(emptyItem(type))
    },
    removeItem (item) {
      const idx = this.block.items.indexOf(item)
      if (idx !== -1) this.block.items.splice(idx, 1)
    },
    async saveBlock () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        errorMessage('Preencha os campos obrigatórios.')
        return
      }
      this.saving = true
      try {
        const payload = {
          ...this.block,
          items: this.block.items.map((i, idx) => ({
            ...i,
            order: i.order || idx,
            boarding_date: this.fromDateTimeLocal(i.boarding_date),
            landing_date: this.fromDateTimeLocal(i.landing_date)
          }))
        }
        if (this.block.id) {
          await this.update(payload)
          successMessage('Bloqueio atualizado.', 2500)
        } else {
          await this.save(payload)
          successMessage('Bloqueio criado.', 2500)
        }
        this.$emit('saved')
        this.close()
      } catch (err) {
        const msg = (err.response && err.response.data && err.response.data.message) || 'Erro ao salvar.'
        errorMessage(msg)
      } finally {
        this.saving = false
      }
    },
    close () {
      this.modal = false
      this.$emit('input', false)
    },
    toDateTimeLocal (dt) {
      if (!dt) return null
      // Aceita "YYYY-MM-DD HH:mm:ss" ou ISO — converte para formato do input datetime-local
      const d = new Date(dt.replace ? dt.replace(' ', 'T') : dt)
      if (isNaN(d.getTime())) return null
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    fromDateTimeLocal (val) {
      if (!val) return null
      // Converte "YYYY-MM-DDTHH:mm" para "YYYY-MM-DD HH:mm:00" (formato MySQL)
      return val.replace('T', ' ') + ':00'
    }
  },
  watch: {
    value (val) {
      this.modal = val
    },
    modal (val) {
      if (!val) this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
.item-card {
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 10px;
}
.item-card label.small {
  margin-bottom: 2px;
  color: #6c757d;
  font-weight: 500;
}
</style>
